import { formatAfipDate, formatCurrency } from '../utils/invoiceQueryUtils';

export const INVOICE_QUERY_TABLE_COLUMNS = [
  { id: 'voucher_type', label: 'Tipo', render: row => row.voucher_type === 6 ? 'B' : row.voucher_type },
  { id: 'total', label: 'Total', render: row => formatCurrency(row.amounts?.total) },
  { id: 'net', label: 'Neto', render: row => formatCurrency(row.amounts?.net) },
  { id: 'iva', label: 'IVA', render: row => formatCurrency(row.amounts?.iva) },
  { id: 'exempt', label: 'Exento', render: row => formatCurrency(row.amounts?.exempt) },
  { id: 'tax', label: 'Impuesto', render: row => formatCurrency(row.amounts?.tax) },
  { id: 'concept', label: 'Concepto', render: row => formatCurrency(row.amounts?.concept) },
  { id: 'cae', label: 'CAE' },
  { id: 'cae_expiry_date', label: 'Vto CAE', render: row => formatAfipDate(row.cae_expiry_date) },
  { id: 'voucher_date', label: 'Fecha', render: row => formatAfipDate(row.voucher_date) }
];

